<script setup lang="ts">
/**
 * SeoCrumbs — the breadcrumb line at the top of an SEO page: pencil-grey links,
 * the current page in ink. (The BreadcrumbList JSON-LD stays on each page.)
 */
import { RouterLink } from 'vue-router';

defineProps<{ items: Array<{ label: string; to?: string }> }>();
</script>

<template>
  <nav class="type-caption mb-7 flex flex-wrap items-center gap-y-1">
    <template
      v-for="(item, i) in items"
      :key="i"
    >
      <span
        v-if="i > 0"
        class="mx-2 text-muted-foreground/60"
      >/</span>
      <RouterLink
        v-if="item.to"
        :to="item.to"
        class="rounded-[var(--paper-radius-xs)] transition-colors hover:text-foreground focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-paper-stock"
      >
        {{ item.label }}
      </RouterLink>
      <span
        v-else
        class="text-foreground"
      >{{ item.label }}</span>
    </template>
  </nav>
</template>
